import Container from '@anm/components/Container';
import TitleBlock from '@anm/components/TitleBlock';
import { flexColumn, flexRow, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const containerWrapperOnMobile = media.phone`
  margin-top: 20px;
  margin-bottom: 50px;
  & > div {
    width: 100%;
  }
  & > div:last-child {
    margin-top: 10px;
  }
`;

export const ContainerWrapper = styled(Container)`
  ${flexRow};
  width: 100%;
  flex-wrap: wrap;
  margin-top: 68px;
  max-height: 480px;
  margin-bottom: 140px;
  & > div {
    width: 50%;
  }
  ${containerWrapperOnMobile};
`;

const titleOnMobile = media.phone`
  padding: 0;
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 26px;
    line-height: 35px;
  }
`;

export const Title = styled(TitleBlock)`
  ${flexColumn};
  padding-left: 20px;
  justify-content: center;
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 32px;
    line-height: 48px;
  }
  & > div {
    font-size: 16px;
    margin-top: 7px;
    max-width: 400px;
    line-height: 28px;
  }
  ${titleOnMobile};
`;

export const PlayerContainer = styled.div`
  position: relative;
  & > div {
    &:after,
    &:before {
      content: '';
      position: absolute;
      background: var(--error_bkg);
    }
    &:after {
      top: 20px;
      right: -20px;
      width: 20px;
      height: 100%;
    }
    &:before {
      top: 100%;
      left: 20px;
      width: 100%;
      height: 20px;
    }
  }
`;
